<template>
  <div class="share" :class="{ 'share--mini': !isClassic }">
    <modal :show-background="isClassic" @close="$emit('close')">
      <template slot="header">
        <h2 class="share__heading">Share</h2>
      </template>
      <template slot="body">
        <div
          :class="
            isClassic ? 'inline-share inline-share-classic' : 'inline-share'
          "
        >
          <div>
            <a
              :href="computedShareLink('facebook')"
              target="_blank"
              :class="
                isClassic ? 'share-email share-email-classic' : 'share-email'
              "
            >
              <img :src="icons.facebook" alt="facebook" />
              <span>Facebook</span>
            </a>
          </div>
          <div>
            <a
              :href="computedShareLink('twitter')"
              target="_blank"
              :class="
                isClassic ? 'share-email share-email-classic' : 'share-email'
              "
            >
              <img :src="icons.twitter" alt="twitter" />
              <span>Twitter</span>
            </a>
          </div>
          <div>
            <button
              @click="copyLink"
              :class="
                isClassic
                  ? 'share-email share-email-classic share-email-button'
                  : 'share-email share-email-button'
              "
            >
              <img :src="icons.copy" alt="facebook" />
              <span>Copy</span>
            </button>
          </div>
          <div>
            <a
              :href="computedShareLink('email')"
              target="_blank"
              :class="
                isClassic ? 'share-email share-email-classic' : 'share-email'
              "
            >
              <img :src="emailIcon" alt="email" />
              <span>Email</span>
            </a>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from './Utils/Modal';

export default {
  components: {
    Modal,
  },
  props: {
    isClassic: Boolean,
    url: {
      type: String,
    },
    title: {
      type: String,
      default: 'default',
    },
    description: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    emailIcon() {
      return require('../assets/v3-assets/email.svg');
    },
    icons() {
      return {
        email: require('../assets/v3-assets/email.svg'),
        twitter: require('../assets/v3-assets/twit.svg'),
        facebook: require('../assets/v3-assets/fb.svg'),
        copy: require('../assets/v3-assets/copy.svg'),
      };
    },

    computedEmailShareLink() {
      const base = 'http://api.addthis.com/oexchange/0.8/forward/mailto/offer';
      const url = this.url;
      const title = this.title;
      return `${base}?url=${url}&title=${title}`;
    },
  },
  ready() {
    this.setupAddthis();
    this.injectAddThisTitles();
  },
  methods: {
    setupAddthis() {
      const src =
        '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-6171613b5ffc0150';
      const hasAddthisScript = document.querySelector(`script[src="${src}"]`);

      if (hasAddthisScript) return;

      const addscript = document.createElement('script');
      addscript.setAttribute('src', src);
      document.head.appendChild(addscript);
    },

    injectAddThisTitles() {
      if (this.isClassic) return;

      setTimeout(() => {
        const labels = this.$el.querySelectorAll('.at-label');
        [...labels].map((label) => {
          label.classList.add('force-label');

          if (label.innerHTML === 'Copy Link') {
            // eslint-disable-next-line no-param-reassign
            label.innerHTML = 'Copy';
            label.parentNode.addEventListener('click', (event) => {
              this.copyLink(event);
            });
          }

          return true;
        });
      }, 1500); // I don't like this, but we need to wait for AddThis to work its magic
    },

    copyLink(event) {
      event.preventDefault();
      navigator.clipboard
        .writeText(this.url)
        .then(() => window.alert('Successfully copied link to clipboard.'))
        .catch((err) => {
          window.alert(
            "Failed to copy to clipboard. Please check your browser's clipboard settings"
          );
          console.log(err);
        });

      const addThis = document.querySelector('#at-expanded-menu-host');
      if (addThis) {
        addThis.remove();
      }
    },
    computedShareLink(type) {
      const url = this.url;
      const title = this.title;
      const createShareLinkFor = (shareCode) =>
        `http://api.addthis.com/oexchange/0.8/forward/${shareCode}/offer?url=${url}&title=${title}`;
      switch (type) {
        case 'email':
          return `mailto:?body=${url}&subject=${title}`;
        case 'twitter':
          return `${createShareLinkFor('twitter')}`;
        case 'copyToClip':
          return `${createShareLinkFor('link')}`;
        case 'facebook':
          return `${createShareLinkFor('facebook')}`;
        default:
          return `${createShareLinkFor('mailto')}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/_variables-v2';

.share {
  &--mini {
    .share__heading {
      margin-bottom: 0.5rem;
    }
  }
  &__heading {
    font-family: $font;
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
}
</style>

<style lang="scss">
.share {
  &--mini {
    .modal__content {
      padding: 0.25rem 1rem !important;
    }

    .modal__button {
      top: 0.5rem !important;
    }

    .at-share-btn-elements {
      display: flex;
      justify-content: space-between;
      flex: 1;
    }

    .at-share-btn {
      background-color: transparent !important;
      padding: 0 0.5rem !important;
      transform-origin: center;
      transform: scale(0.8);
      display: flex !important;
      flex-direction: column;
      align-items: center;
      margin: 0 !important;
      &:hover {
        transform: scale(0.8) !important;
      }
    }

    .at-icon {
      fill: #000 !important;
    }

    .share__heading {
      margin-bottom: 0 !important;
      font-size: 1rem;
    }
  }
}

.at-expanded-menu-hd,
.at-branding-logo {
  display: none !important;
}

.at-copy-link-share {
  transform: scale(0.8) !important;
  transform-origin: top;
  position: relative;
  top: -1rem;
}

.modal {
  &__content {
    padding: 0.5rem 1rem !important;
  }
  &__button {
    top: 1rem !important;
    right: 1rem !important;
  }
}

.force-label {
  color: #000 !important;
  display: block !important;
  line-height: 1 !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}

.inline-share {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.addthis_inline_share_toolbox-mini {
  flex: 1;
  margin-right: 75px;
}

.share-email {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  align-items: center;
  margin-top: 6px;
  img {
    height: 20px;
    width: 20px;
  }

  span {
    font-size: 11.4px;
    text-decoration: none;
    color: #000;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
}

.share-email-classic {
  margin-top: 0px;
  span {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    margin-top: 10px;
  }
  img {
    height: 40px;
    width: 40px;
  }
}

.share-email-button {
  background: none;
  border: none;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// Share.vue?2341c3a5